import React from 'react';
import { formatCurrency } from '../../utils/index.ts';
import CalculationTooltip, { type TooltipBreakdownRow } from './CalculationTooltip.tsx';

interface SummaryRowProps {
  label: string;
  value: number | string | null | undefined;
  breakdown?: TooltipBreakdownRow[];
}

const SummaryRow = ({ label, value, breakdown }: SummaryRowProps) => (
    <div className="flex justify-between items-center text-sm border-b border-gray-700 pb-2">
        <CalculationTooltip title={`${label} Calculation`} data={breakdown}>
            <span className={`flex items-center gap-1 text-gray-400 ${breakdown ? 'cursor-help underline decoration-dotted decoration-gray-500 underline-offset-2' : ''}`}>
                {label}
            </span>
        </CalculationTooltip>
        <span className="font-semibold text-gray-200">{formatCurrency(value)}</span>
    </div>
);

export default SummaryRow;
